function normalizeId(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function normalizeIds(value) {
  return Array.isArray(value) ? value.map(normalizeId).filter(Boolean) : [];
}

export function isFamilyMembershipMember(member = {}) {
  if (member.membershipCoverageType === 'additional') return false;
  const coverageType = normalizeId(member.membershipCoverageType).toLowerCase();
  const planType = normalizeId(member.membershipPlanType).toLowerCase();
  if (coverageType === 'family'
    || member.paymentMode === 'family_covered'
    || planType === 'family_tier') return true;
  // Shared payment ownership alone does not turn an explicit individual plan
  // into a family plan. Legacy records without a type can still use links.
  if (coverageType === 'individual' || planType === 'individual') return false;
  return Boolean(normalizeId(member.membershipCoveredByUid))
    || Boolean(normalizeId(member.membershipCoveredByFamilyId))
    || normalizeIds(member.membershipCoveredMemberIds).length > 1;
}

export function getMembershipPlanLabel(member = {}) {
  const storedLabel = normalizeId(member.membershipPlanSnapshot?.label)
    || normalizeId(member.membershipPlanLabel);
  if (isFamilyMembershipMember(member)) {
    return storedLabel && !/^individual membership$/i.test(storedLabel)
      ? storedLabel
      : 'Family Membership';
  }
  return storedLabel || 'Individual Membership';
}

export function summarizeMemberships(members = []) {
  const currentMemberIds = new Set(
    members.map((member) => normalizeId(member?.id)).filter(Boolean)
  );
  const familyMemberIds = new Set();
  const familyMembershipKeys = new Set();

  members.forEach((member, index) => {
    if (!isFamilyMembershipMember(member)) return;
    const memberId = normalizeId(member.id) || `member-${index}`;
    familyMemberIds.add(memberId);
    normalizeIds(member.membershipCoveredMemberIds).forEach((id) => {
      if (currentMemberIds.has(id)) familyMemberIds.add(id);
    });

    const groupKey = normalizeId(member.membershipCoveredByUid)
      || normalizeId(member.membershipPaymentOwnerUid)
      || normalizeId(member.membershipCoverageFamilyId)
      || normalizeId(member.membershipCoveredByFamilyId)
      || memberId;
    familyMembershipKeys.add(groupKey);
  });

  return {
    totalMembers: members.length,
    individualMembers: Math.max(0, members.length - familyMemberIds.size),
    familyMembers: familyMemberIds.size,
    familyMemberships: familyMembershipKeys.size,
  };
}
